import PropTypes from "prop-types";
import React, { useEffect } from "react";

import { useAIDashboardStore } from "../context/AIDashboardContext";

const CanvSelectTeamId = ({ channel, value }) => {
  const store = useAIDashboardStore(channel);
  const publish = store((state) => state.publish);

  useEffect(() => {
    if (value) {
      publish({ id: value });
    }
  }, [publish, value]);

  return <div style={{ display: "none" }}>{value}</div>;
};

CanvSelectTeamId.propTypes = {
  channel: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default CanvSelectTeamId;
